import { Box, styled } from '@mui/material';
import { darken } from '@mui/material/styles';

export const StyledBox = styled(Box)(({ theme }) => ({
	position: 'sticky',
	top: 'var(--app-safe-area-top)',
	zIndex: theme.zIndex.appBar,
	clipPath: 'inset(0 0 -24px 0)',
	flexGrow: 1,
}));

export const StyledSearchBar = styled(Box)(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	gap: theme.spacing(1),
	backgroundColor: darken(theme.palette.secondary.main, 0.11),
	padding: '4px 16px',
}));
